import { startCase } from "lodash";
import MainLayout from "../../../components/MainLayout";
import LibraryLayout from "../../../components/LibraryLayout";
import { listImagesFromAllSources } from "../../api/list";
import { getCategories, getCategory } from "../../../services/categories";
import { useContext } from "react";
import UserContext from "../../../components/UserContext";

export default function Home(props) {
    const { user, supabase } = useContext(UserContext);
    return (
        <LibraryLayout
            section={"categories"}
            subsection={props.name}
            supabase={supabase}
            {...props}
        >
            <MainLayout
                key={props.name}
                supabase={supabase}
                {...props}
                baseUrl={`/category/${props.name}`}
            />
        </LibraryLayout>
    );
}

export async function getStaticPaths() {
    const categoriesExt = require("../../../categories-ext.json").categories;
    const rawCategories = require("../../../categories.json").categories;
    const allCategories = categoriesExt.concat(rawCategories);
    return {
        paths: allCategories.map((c) => ({ params: { category: c.name } })),
        fallback: true,
    };
}

export async function getStaticProps(context) {
    const cat = context.params.category;
    const category = await getCategory(cat);

    if (!category) {
        return {
            notFound: true,
        };
    }

    const result = await listImagesFromAllSources(0, cat);

    let categories = await getCategories();

    return {
        props: {
            ...category,
            initialImages: result,
            query: cat,
            title: `${startCase(cat)} Vector Images and Illustrations for Free Download`,
            canLoadMore: true,
            categories: categories.map((c) => ({ name: c.name })),
        },
    };
}
